import { useState, type ReactNode } from 'react';
import { Dialog } from './ui';

/** «Вы уверены?» before an action that moves money, signs something or takes access away. The caller closes it. */
export function ConfirmDialog({
  open,
  onClose,
  title,
  children,
  confirmLabel,
  onConfirm,
  pending,
  quiet,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  pending?: boolean;
  /** A lighter question (the secondary button): revokes, not payments. */
  quiet?: boolean;
}) {
  return (
    <Dialog open={open} onClose={onClose} title={title}>
      <div className="space-y-4 p-5">
        <div className="text-sm">{children}</div>
        <div className="flex justify-end gap-2">
          <button type="button" className="btn-secondary" onClick={onClose}>
            Отмена
          </button>
          <button type="button" className={quiet ? 'btn-secondary' : 'btn-primary'} disabled={pending} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

/** A button that asks first; `onConfirm` runs on «да» and the question closes. */
export function ConfirmButton({
  label,
  className,
  title,
  children,
  confirmLabel,
  onConfirm,
  disabled,
  quiet,
}: {
  label: ReactNode;
  className: string;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  disabled?: boolean;
  quiet?: boolean;
}) {
  const [asking, setAsking] = useState(false);
  return (
    <>
      <button type="button" className={className} disabled={disabled} onClick={() => setAsking(true)}>
        {label}
      </button>
      <ConfirmDialog
        open={asking}
        onClose={() => setAsking(false)}
        title={title}
        confirmLabel={confirmLabel}
        quiet={quiet}
        onConfirm={() => {
          setAsking(false);
          onConfirm();
        }}
      >
        {children}
      </ConfirmDialog>
    </>
  );
}
